export const testimonials = [
  {
    desc: "Last year I had reason to call Linda to my property as we were experiencing unexplained goings-on that were making my family feel unsettled and frightened. Linda was very professional and at the same time comforting in the way she handled the situation. I would fully recommend Linda; since her visit there has been no activity and she left a calming atmosphere in our home.",
    author: "Michelle, Wirral",
  },

  {
    desc: "Linda did a clearing for me on land near my house that made myself and my family very uncomfortable to travel through. She did an amazing job and the lightness and calmness are amazing. I highly recommend Linda, who is an amazing person and an angel on earth 🥰",
    author: "Lorraine, Kildare",
  },

  {
    desc: "Linda is truly a wonderful medium. She connects with spirit in a respectful and loving way. It feels like our loved ones are in the room with us and you can feel their love in your heart. With Linda's help and the angels she works with, you will really enjoy your reading and feel a sense of peace and connection.",
    author: "Frances, Kildare",
  },

  {
    desc: "Linda did a clearing in my home. She mainly focused on one room and was professional, genuine and focused. The whole house now has a lovely clear energy and we are so happy with the results.",
    author: "Francis, Kildare",
  },

  {
    desc: "There was clearly unsettling spiritual activity in my house and I was so concerned, I contacted Linda Rooney, as she had been recommended to me by a friend. To my amazement, all activity ceased and I was left with a home that felt calm and peaceful. I would certainly recommend Linda as she is not only friendly and pleasant but very good at what she does.",
    author: "Karen, Wirral",
  },

  {
    desc: "We had the pleasure of working with Linda Rooney after purchasing our property in 2023. While the land was beautiful, there was a heaviness in the air we couldn’t quite explain—until Linda performed her energy clearing. Her intuitive and gentle approach brought an immediate shift. The atmosphere became lighter, more vibrant—like a fresh breeze had passed through. Our home now feels like a sanctuary of peace and joy. Linda’s gift is truly extraordinary, and we’re deeply grateful for the transformation she brought to our lives and our land.",
    author: "Grainne, Tipperary",
  },
  {
    desc: "I had Linda come and do a home and land energy clearance in my home. After receiving good news regarding my health I wanted to clear the heavy energy of stress and worry of the past year from my environment. I wanted a reset. I absolutely loved the results; the lighter, brighter energy is now the perfect space to continue my healing. Thank you, Linda; I am so very grateful. 🙏",
    author: "Maria, Dublin",
  },
  {
    desc: "Where do I begin? I inherited a farmhouse with a bit of land from my uncle in County Cork. I loved everything about it, but my youngest daughter, my wife, and even the dog really didn’t like the paddock behind the old stable. Friends said the same—something just felt off. My sister told me about Linda, so we called her. She spent time chatting with us before working, and we instantly felt like we were with a friend. Now the paddock and the whole area feel lighter and brighter. It’s peaceful, as if a warm light is shining over it. We’ll forever sing Linda’s praises. Thank you, Linda!",
    author: "Garry, Cork",
  },
  {
    desc: "I had an amazing experience with Linda. She did an energy clearing on my home, and I could genuinely feel the shift. The atmosphere feels lighter, more peaceful, and just better. I didn't expect to notice such a clear difference, but the energy in my home is noticeably calmer and more positive. She's intuitive, professional, and clearly gifted at what she does. Highly recommend to anyone looking to reset the energy in their home.",
    author: "Hazel, Kildare",
  },
  {
    desc: "Linda is an amazing psychic and medium—authentic, honest, and an accurate reader of your soul's energy. I've seen her bring through whole families in heaven, sharing names and intimate details. Her integrity, sensitivity, and warm communication style offer profound comfort. Of all the mediums I've trained and know in Ireland, she's among the few I'd trust with my loved ones. I recommend Linda wholeheartedly; she'll bring you comfort, support, and peace on both a psychic and mediumistic level. Gerry Coleman, therapist and psychic/mediumship trainer.",
    author: "Gerry, Kildare",
  },
  {
    desc: "Linda's energy is bubbly and filled the house with joy and happiness. The house feels cleansed and blessed by the Angels.",
    author: "Jason, Mountshannon",
  },
  {
    desc: "Linda came and done an energy clearance in our new home, we had been feeling the energy was a little off and wanted to allow our own energy be the main character in our new family home. Linda has a beautiful aura and a kind presence, she made sure to explain her method to us prior to put us at ease and got to work in our home. The results were instant and a lightness came in with the shift of energy. We are beyond delighted and can't thank Linda enough.",
    author: "Grainne, Clondalkin",
  },
];

export const FAQs = [
  {
    question: "What does it mean that everything holds energy?",
    answer:
      "Land, homes, and businesses absorb energy from past events, emotions, and activities. Stagnant or negative energy can affect the well-being of those who live or work there.",
  },
  {
    question: "How does historical influence affect energy?",
    answer:
      "The history of a place, including traumatic events, conflicts, or previous occupants’ emotions, can leave energetic imprints that influence the present.",
  },
  {
    question: "What are the signs of negative energy in a place?",
    answer:
      "Common indicators include frequent conflicts, unexplained fatigue, difficulty selling a property, business struggles, or feeling uneasy in certain spaces.",
  },
  {
    question: "What are some methods for cleansing negative energy?",
    answer:
      "Techniques include smudging with sage, using sound vibrations (bells, singing bowls), salt purification, Reiki, or prayers and blessings from different spiritual traditions.",
  },
  {
    question: "Which crystals are best for protection?",
    answer:
      "Black tourmaline, selenite, and clear quartz are commonly used to absorb or transmute negative energy in homes and businesses.",
  },
  {
    question: "How does Feng Shui relate to spiritual healing?",
    answer:
      "The flow of chi (energy) can be improved by decluttering, rearranging furniture, and incorporating elements like plants and water features.",
  },
  {
    question: "Why is intention important in cleansing rituals?",
    answer:
      "Setting a clear, positive intention before cleansing enhances effectiveness. Visualizing light, peace, and prosperity helps shift the energy.",
  },
  {
    question: "Why do energy workers cleanse during moon cycles?",
    answer:
      "Many energy workers prefer cleansing during a full or new moon, as these phases amplify energetic shifts.",
  },
  {
    question: "How can energy cleansing benefit businesses?",
    answer:
      "Prosperity rituals, affirmations, and regular clearing of stagnant energy can help businesses thrive by attracting success and positive interactions.",
  },
  {
    question: "What is land healing and why is it needed?",
    answer:
      "Sacred sites, battlefields, or places with traumatic pasts may require deep energy healing using ceremonies, crystal grids, or earth offerings.",
  },
];

export const RIGHT_ORIENTATION = "RIGHT_ORIENTATION";
export const LEFT_ORIENTATION = "LEFT_ORIENTATION";
